// ##############################
// // // Dashboard View styles
// #############################

import {
  successColor,
  tooltip
} from "assets/jss/material-dashboard-pro-react.jsx";

const dashboardStyle = {
  successText: {
    color: successColor
  },
  upArrowCardCategory: {
    width: 14,
    height: 14
  },
  underChartIcons: {
    width: "17px",
    height: "17px"
  },
  tooltip
};

export default dashboardStyle;
